export default __webpack_public_path__ + "static/Lexend-Regular-66f3898e74813ae2364610e8d8068818.woff2";